import {userService} from "../../../../api";
import PbTwitterTokenGet from '../../../../../pb/webauthtwitterrequesttokenpro.pb';

let getRequestToken = () => {
    let baseUrl = Uplib.url.delQuery(location.href, 'oauth_token');

    baseUrl = Uplib.url.delQuery(baseUrl, 'oauth_verifier');
    baseUrl = Uplib.url.delQuery(baseUrl, 'code');

    userService('/webauth/twitter/requesttoken/pro', PbTwitterTokenGet.WebAuth.TwitterRequestTokenPro)({
        callback: encodeURIComponent(baseUrl)
    }).then(resp => {
        $.channel.emit('getTwitterOauthTokenSuccess', resp);
    }).catch(() => {
        Uplib.notification.simple('request fail');
    });
};

export default {
    getRequestToken
};



// WEBPACK FOOTER //
// ./js/component/openjs/deps/login/sns/twitter.js